module.exports = __webpack_public_path__ + "media/images/emblems/Lavigny-coat_of_arms-9275aab2c433515ed57ef76d9c647c88.svg";